function smokeOnLoad()
{
   let lowerTextDOM = document.querySelector('.lowerText');
   lowerTextDOM.innerHTML = 'Text from javascript.';
	
}